import * as React from "react";
import { withRouter } from "react-router-dom";

const ScrollToTopOnMount = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export default withRouter(ScrollToTopOnMount);
